import { defineStore } from 'pinia';
import { usePage } from '@inertiajs/vue3';
import { AuthUser } from '../Interfaces/AuthUser';
import requestPhoto from '../utils/request_photo';

interface MenuOption {
	title: string;
	url?: string;
	sub?: Array<MenuOption>;
	action: Function;
}

export const menuStore = defineStore('menuStore', {
	state: () => ({
		mobile_menu_open: false,
		meeting_page: false,
		side_menu_items: JSON.parse(
			JSON.stringify(usePage().props?.side_menu_items)
		) as Array<MenuOption>,
		auth_user: usePage().props?.auth_user as AuthUser,
		option: JSON.parse(
			JSON.stringify(usePage().props?.student_meeting_biometry_options)
		),
        datetime: null as null|string
	}),
	actions: {
		mobileMenuOpenClose() {
			this.mobile_menu_open = !this.mobile_menu_open;
		},
		isMeetingPage() {
			this.meeting_page = true;
		},
		addStudentStartingClassBiometryOption() {
			if (this.auth_user.user_role === 3 && this.meeting_page) {
				const option = this.option;
				const index = this.side_menu_items.length - 1;

				option.sub = option.sub.filter(
					(item) => item.title === 'Abrir Aula'
				);
				// option.sub[0].action = () => {}
				//@ts-ignore
				option.sub[0].action = () => $('#button-start-class').click();
				this.side_menu_items.splice(index, 0, option);
			}
		},
		addStudentValidateBiometryOption() {
			if (this.auth_user.user_role === 3 && this.meeting_page) {
				const option = this.option;
				const index = this.side_menu_items.length - 1;

				option.sub = option.sub.filter(
					(item) => item.title === 'Validar Biometria'
				);
				//@ts-ignore
				option.sub[0].action = () =>
					$('#button-middle-validate').click();
				this.side_menu_items.splice(index, 0, option);
			}
		},
		addStudentCloseClassBiometryOption() {
			if (this.auth_user.user_role === 3 && this.meeting_page) {
				const option = this.option;
				const index = this.side_menu_items.length - 1;

				option.sub = option.sub.filter(
					(item) => item.title === 'Fechar Aula'
				);
				//@ts-ignore
				option.sub[0].action = () => $('#button-close-class').click();
				this.side_menu_items.splice(index, 0, option);
			}
		},
		resetStudentSpecialOptions() {
			this.side_menu_items = JSON.parse(
				JSON.stringify(usePage().props?.side_menu_items)
			);
			this.option = JSON.parse(
				JSON.stringify(
					usePage().props?.student_meeting_biometry_options
				)
			);
		},
		addTheRequestForPhotoOnLogout() {
			if (this.auth_user.user_role === 3) {
				const is_login = false;

				const logout_option =
					this.side_menu_items[this.side_menu_items.length - 1];
				logout_option.action = () => requestPhoto(is_login);
			}
		},
        setDateTime(datetime: string|null) {
            this.datetime = datetime;
        }
	},
});
